import { Close } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/joy";
import { format, parse } from "date-fns";
import { ApiTaskSet } from "griptonite-api-client/types/tasks";

import Sidebar, { SidebarHeader } from "../Sidebar";
import { useCalendar } from "./CalendarContext";
import { TasksetEventCard } from "./TaskSetEventCard";

type Props = {
  events: ApiTaskSet[];
  onClose: () => void;
  date: string;
};

export default function EventsSidebar({ events, onClose, date }: Props) {
  const { setContextMenu } = useCalendar();
  const formattedDate = format(parse(date, "yyyy-MM-dd", new Date()), "do MMMM");
  return (
    <Sidebar
      sx={{
        borderTopLeftRadius: 16,
        borderLeft: "1px solid",
        borderLeftColor: "neutral.200",
      }}
    >
      <SidebarHeader>
        <Typography level="title-lg">{formattedDate}</Typography>
        <IconButton
          sx={{
            backgroundColor: "neutral.200",
            borderRadius: "100%",
            "&:hover": {
              backgroundColor: "neutral.800",
            },
          }}
          onClick={() => onClose()}
        >
          <Close />
        </IconButton>
      </SidebarHeader>
      <Stack
        sx={{
          flex: 1,
          height: "100%",
          overflow: "auto",
        }}
        gap={1}
      >
        {events.map((event) => (
          <TasksetEventCard
            expandedName
            taskSet={event}
            key={event.uuid}
            onContextMenu={(e) => {
              e.preventDefault();
              setContextMenu({
                taskSet: event,
                x: e.clientX,
                y: e.clientY,
              });
            }}
          />
        ))}
      </Stack>
    </Sidebar>
  );
}
